module.exports = __webpack_public_path__ + "static/media/50.48da39fe.jpg";